import { Direccion, DireccionDTO } from "./direccion";
import { Identificacion, TipoPersona } from "./identificacion";
import { DatosComercial } from "./datoscomercial";
import { FormaPagoMovimientoCaja } from "./movimientocaja";
import { ClienteDescripcionPaquete, ClienteDescripcionPaqueteDTO } from "./ClienteDescripcionPaquete";
import { ResidenciaFiscalCliente, ResidenciaFiscalClienteDTO } from "./residenciafiscalcliente";

type DatosComercialCliente = DatosComercial;
type IdentificacionCliente = Identificacion;
type IdentificacionContactoCliente = Identificacion;
/**Un contacto de un cliente, note que los contactos no son por cliente, si no por cada dirección del cliente */
export interface ContactoCliente {
    IdRegistro: number;

    /**Nombre de la persona */
    Nombre: string;

    /**Dirección del cliente */
    IdDireccionCliente: number;

    /**Identificación de la persona */
    Identificacion: IdentificacionContactoCliente;

    /**
   * True si esta persona esta autorizada para recibir paquetes de este cliente en esta dirección. Esta opción solamente aplica si cliente tiene @see Cliente.SoloRecibirContactosAutorizado 
   */
    AutorizadoRecibir: boolean;

    /**Telefono del cliente */
    Telefono: string;
     /**Email del cliente */
    Email:string
}

/**Un contacto de un cliente, note que los contactos no son por cliente, si no por cada dirección del cliente */
export interface ContactoClienteDTO extends ContactoCliente {
    DireccionCliente: DireccionClienteDTO;
}


/**Un cliente del sistema */
export interface Cliente {
    IdRegistro: number;

    Nombre: string;
    AceptaFletePorCobrar: boolean;

    /**Indica si se agruparán las guías en un solo concepto de factura al facturar las guías */
    AgruparGuiasAlFacturar: boolean;

    /**Indica si se mostrara el precio al imprimir guiasPP */
    ImprimirPrecioGuiaPP: boolean;

    /**Indica si se mostrara el precio al imprimir guiasPP */
    ImprimirPrecioGuia: boolean;

    /**Indica si se mostrara el precio al imprimir guiasPP */
    SeguroViaje: boolean;

    /**Numero de poliza si no tiene seguro de viaje*/
    NumeroPoliza: string;

    /**Si es true el cliente recibirá correos informando del status de la guía */
    RecibirCorreoStatusGuia: boolean;

    /**Correo del cliente */
    CorreoCliente: string;

    DatosFacturacion: DatosFacturarCliente;

    /**Id de la ciudad de la diraccion de facturacion */
    IdDatosFacturacionColonia: number | null;

    /**Id de vendedor */
    IdVendedor: number;

    /**Tarifa especial que aplica para este cliente. Si es null aplica la tarifa general. Este es el convenio */
    IdTarifa: number | null;

    /**Direcciones del cliente */
    Direcciones: DireccionCliente[];

    /**True si el cliente acepta flete por cobrar en zonas extendidas */
    AceptaFxcZe: boolean;

    ClientesFinales: ClienteDeCliente[];

    /**Representa las relaciones que tiene este cliente con las descripciones de paquetes */
    DescripcionesPaquetes: ClienteDescripcionPaquete[];

    /**Información de los datos comerciales del cliente para futuros reportes estadísticos */
    DatosComercialCliente: DatosComercialCliente;

    /**Identificación del cliente, debe de tener por lo menos un campo unico y asignado */
    IdentificacionCliente: IdentificacionCliente;

    /**Cuando un paquete sea enviado, el sistema va a validar que la persona que recibe el paquete sea uno de los contactos autorizados. Si no esta habilitada esta opción cualquier persona podrá recibir el paquete del cliente */
    SoloRecibirContactosAutorizado: boolean;

    /**Colonia de la direccion de cobranza de los datosCredito */
    IdDatosCreditoColonia: number | null;

    /**Datos de cobranza */
    DatosCredito: DatosCredito;

    /**En caso de que el cliente acepte creditos es la sucursal donde se realizan los viajes de revisión y cobranza */
    IdSucursalCobranza: number | null;

    /**Es la fecha de inicio del cliente para las comisiones */
    FechaDeInicioParaComisiones: Date | string;

    /**Telefono del cliente */
    Telefono: string;

    /**Si es true este cliente solo podrá ver las descripciones de paquete que tiene relacionadas */
    VerSoloDescripcionesPaquetesRelacionados: boolean;

    /**si es true esté cliente será visible unicamente para los clientes que lo tengan relacionado */
    VisibleExclusivoClientesRelacionados: boolean;

    /**si s true este cliente únicamente podrá ver los clientes que tiene relacionado y a si mismo */
    VerSoloClientesRelacionados: boolean;

    /**Indica si se utilizará el convenió de este cliente para las guías que sean de FXC */
    UtilizarConvenioPropioEnFXC: boolean;
     
    CalculoEspecialDeGuias: boolean;
    
    TomarSucursalCobranzaDefault: boolean;

    CobrarImporteGastoAdministrativo: boolean;

    CartaPorteEspecialSepararGuias: boolean;

    AumentarPresicionDeDecimales: boolean;

}

/**Una direccion de origen o destino de un cliente */
export interface DireccionCliente {
    IdRegistro: number;

    /**De quien es esta dirección */
    IdCliente: number;
    Cliente: Cliente;

    /**Datos de la dirección del cliente */
    Direccion: Direccion;
    IdColonia: number;

    /**Contactos de esta dirección */
    Contactos: ContactoCliente[];

    /**Telefono del cliente */
    Telefono: string;
     /**Email del cliente */
    Email:string;
}

export interface DireccionClienteDTO extends DireccionCliente {
    Direccion: DireccionDTO;
}

export interface ClienteDTO extends Cliente {
    NombreVendedor: string;
    DireccionFacturacion: DireccionDTO;
    Direcciones: DireccionClienteDTO[];
    /**Dirección del cliente para mostrar en los selectores de clientes */
    PrimeraDireccion: DireccionClienteDTO;
    ClientesFinales: ClienteDeClienteDTO[];
    DescripcionesPaquetes: ClienteDescripcionPaqueteDTO[];
    Contactos: ContactoCliente[];

    NombreTarifa: string;
    NombreSucursalCobranza: string;

    /**Cargos que se le han hecho al credito del cliente a la fecha de consulta */
    CargosCredito: number;
    /**Abonos que se le han hecho al credito del cliente */
    AbonosCredito: number;
    /**Saldo actual de credito del cliente */
    SaldoCredito: number;
}

/**VIEW de los clientes que se utiliza por motivos de rendimiento */
export interface ClienteView {
    /**Id del cliente */
    IdCliente: number;
    Cliente: Cliente;

    Nombre: string;
    Telefono: string;
    AceptaFletePorCobrar: boolean;
    TipoPersona: TipoPersona;
    Ine: string;
    Rfc: string;
    Curp: string;
    Pasaporte: string;
    LimiteCredito: number | null;
    DiaCobranza: DiaSemana;
    DiaRevision: DiaSemana;
    PrimeraDireccion: string;
    DireccionFacturacion: string;
    NombreTarifa: string;

    CargoCredito: number;
    AbonoCredito: number;
    SaldoCredito: number;

    IataSucursalCobranza: string;
    NombreVendedor: string;
    RegimenFiscal: CodigoRegimenFiscal;
}

export interface ClienteViewDTO extends ClienteView {
    IdTarifa: number | null;
}

/**DTO con los datos de crédito del cliente */
export interface ClienteCreditoDto {
    IdCliente: number;
    Nombre: string;
    CargoCredito: number;
    AbonoCredito: number;
    SaldoCredito: number;
    LimiteCredito: number | null;
    CreditoRestante: number;
    CreditoBloqueado: boolean;
}

export enum DiaSemana {
    Lunes,
    Martes,
    Miercoles,
    Jueves,
    Viernes,
    Sabado,
    Domingo
}

export interface DatosCredito {
    /**Dia establecido para la salida a revisión */
    DiaRevision: DiaSemana;
    /**Dia establecido para la salida a cobranza */
    DiaCobranza: DiaSemana;

    /**Limite de crédito del cliente, es nulo si no tiene credito */
    LimiteCredito: number | null;

    /**Cantidad de dias que se le da al cliente para pagar sus guias */
    DiasCredito: number;

    /**Forma de pago en el cobro de credito. Esta es la forma de pago que van a tomar las facturas de cobranza y los movimientos de caja de los cobros */
    FormaPago: FormaPagoMovimientoCaja;

    /**Direccion de cobranza del cliente */
    DireccionCobranza: Direccion;

    /**Si es true significa que esté cliente tiene bloqueada su linea de crédito */
    CreditoBloqueado: boolean;

}

/**Datos de facturación de un cliente */
export interface DatosFacturarCliente {
    Direccion: Direccion;
    CorreoFacturacion: string;

    /**Atributo condicional para expresar el número de registro de identidad fiscal del receptor cuando sea residente en el extranjero. Es requerido cuando se incluya el complemento de comercio exterior. */
    NumeroRegistroIdentidadFiscal: string;

    /**Atributo condicional para registrar la clave del país de residencia para efectos fiscales del receptor del comprobante, cuando se trate de un extranjero, y que es conforme con la especificación ISO 3166-1 alpha-3. Es requerido cuando se incluya el complemento de comercio exterior o se registre el atributo NumRegIdTrib. */
    ResidenciaFiscal: string;

    /**Numero de cuenta ordenante el cual se va a tomar al crear facturas de este cliente */
    NoCuentaOrdenante: string;

    CodigoRegimenFiscal: CodigoRegimenFiscal;

    NombreFiscal: string;
}

/**Filtro de los clientes */
export interface FiltroCliente {


    /**Busqueda de texto por nombre */
    Nombre?: string;
    /**Para mostrar solo un cliente */
    IdRegistro?: number | null;
    Ine?: string;
    TipoPersona?: TipoPersona;
    Rfc?: string;
    Curp?: string;
    Pasaporte?: string;
    /**Cantidad limite de clientes */
    Limite?: number;
    /**Si el cliente es de crédito o no */
    EsDeCredito?: boolean | null;
}

/**DTO para los datos por default de un nuevo cliente */
export interface DatosDefaultNuevoClienteDto {
    IdFormaPago: number;
    IdMetodoPago: number;
}

export interface ClienteDeCliente {

    IdRegistro: number;

    /**Cliente maestro de la relación */
    IdClienteMaestro: number;

    /**Cliente final de la relación */
    IdClienteFinal: number;
}

export interface ClienteDeClienteDTO extends ClienteDeCliente {
    NombreClienteFinal: string;
    TelefonoClienteFinal: string;
    TarifaClienteFinal: string;
    ClienteFinalAceptaFXC: boolean;
}

export enum CodigoRegimenFiscal {
    _601,
    _603,
    _605,
    _606,
    _607,
    _608,
    _609,
    _610,
    _611,
    _612,
    _614,
    _615,
    _616,
    _620,
    _621,
    _622,
    _623,
    _624,
    _625,
    _626,
    _628,
    _629,
    _630
}


// WEBPACK FOOTER //
// ./app/models/cliente.ts